import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import './index.scss';

interface InputProps {
  name: string;
  label?: string;
  id: string;
  defaultCountry?: any;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any) => void;
  onChange?: (_: any, name: string) => void;
}

const PhoneInputComponent: React.FC<InputProps> = ({
  label,
  id,
  defaultCountry,
  disabled,
  name,
  required,
  error,
  errorMessage,
  className,
  placeholder,
  type,
  value,
  onBlur,
  onKeyDown,
  onChange,
}) => {
  const [focused, setFocused] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    if (value) {
      const strVal = String(value);
      let numericVal = '';
      if (strVal.startsWith('+91')) {
        numericVal = strVal.slice(3).replace(/\D/g, '');
      } else {
        numericVal = strVal.replace(/\D/g, '');
      }
      // Format: "12345 67890"
      if (numericVal.length > 5) {
        setInputValue(`${numericVal.slice(0, 5)} ${numericVal.slice(5)}`);
      } else {
        setInputValue(numericVal);
      }
    } else {
      setInputValue('');
    }
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    // Allow only numeric input
    const numericVal = val.replace(/\D/g, '');

    if (numericVal.length > 10) return;

    // Format for display
    if (numericVal.length > 5) {
      setInputValue(`${numericVal.slice(0, 5)} ${numericVal.slice(5)}`);
    } else {
      setInputValue(numericVal);
    }

    if (onChange) {
      // If empty, return empty; otherwise prepend +91
      const newValue = numericVal ? `+91${numericVal}` : '';
      onChange({ target: { value: newValue } }, name);
    }
  };

  return (
    <>
      <div
        className={clsx(
          'form-control d-flex align-items-center PhoneInput',
          className,
          disabled && 'disabled pe-none',
          error && 'is-invalid',
          focused && !error && 'border-2 border-primary'
        )}
        style={{ paddingLeft: '12px' }} // Standard padding alignment
      >
        <span className="me-2 user-select-none">+91</span>
        <input
          id={id}
          name={name}
          type="text" // Always text to control numeric input better
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder={placeholder}
          disabled={disabled}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            setFocused(false);
            onBlur && onBlur(e, name);
          }}
          onKeyDown={onKeyDown}
          autoComplete="off"
          className="w-100 border-0 bg-transparent p-0 shadow-none focus-ring-none"
          style={{ outline: 'none' }}
        />
      </div>
      {label && (
        <label
          htmlFor={id}
          className={clsx(disabled && 'text-muted', focused && 'text-primary')}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      {error && (
        <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
          <div data-field={id} data-validator="notEmpty">
            {errorMessage}
          </div>
        </div>
      )}
    </>
  );
};

export default PhoneInputComponent;
